module.exports = __webpack_public_path__ + "6477915bbcb7c8fe7beee41da913e532.svg";